import type { AuthenticatedUser } from "../../api/auth";
import type { LaunchpadTile } from "../../components/Launchpad";
import { YardListPage } from "./applications/yard-list/YardListPage";
import { TransportListPage } from "./applications/transport-booking/TransportListPage";
import PartnerTransportListPage from "../default/PartnerTransportListPage";
import { CheckinCheckoutApp } from "./applications/checkin-checkout/CheckinCheckoutApp";
import { PreCheckinApp } from "./applications/pre-checkin/PreCheckinApp";
import { PlanningOverviewPage } from "./applications/planning-overview/PlanningOverviewPage";
import { QualityCheckPage } from "./applications/quality-check/QualityCheckPage";
import { TransportPlanningPage } from "./applications/transport-planning/TransportPlanningPage";
import { UserManagementPage } from "../../components/UserManagement/UserManagementPage";
import { getGlobalLaunchpadTiles } from "../globalApplications.js";
import { TenantContainer } from "../TenantContainer";

// Tenant-spezifische Kacheln-Konfiguration (Pfleiderer)
const TENANT_TILES: LaunchpadTile[] = [
  {
    id: "yard-list",
    title: "Hofliste",
    description: "Übersicht aller Fahrten mit Filter- und Detailansicht",
    path: "/yard-list"
  },
  {
    id: "transport-booking",
    title: "Zeitfensterbuchung",
    description: "Planung von Sammeltransporten mit Zeitfenster-Verwaltung",
    path: "/transport-booking"
  },
  {
    id: "planning-overview",
    title: "Planungsübersicht",
    description: "Wochenkalender mit Zeitfenstern und Kapazitätsmanagement pro Fraktion",
    path: "/planning-overview"
  },
  {
    id: "quality-check",
    title: "Qualitätsprüfung",
    description: "Prüfung und Bearbeitung von Transporten auf dem Hof und im Lager",
    path: "/quality-check"
  },
  {
    id: "transport-planning",
    title: "Transportplanung",
    description: "Z_TPLAN - Transportplanung mit Bedarf, Verträgen und Transporten",
    path: "/transport-planning"
  },
  {
    id: "checkin-checkout",
    title: "Check-in & Check-out",
    description: "Geführter Prozess für Fahrer mit Transportprüfung und Abmeldung",
    path: "/checkin-checkout"
  }
];

const TENANT_ROUTES = [
  { path: "/yard-list", element: <YardListPage /> },
  { path: "/transport-booking", element: <TransportListPage /> },
  { path: "/partner-transports", element: <PartnerTransportListPage /> },
  { path: "/checkin-checkout", element: <CheckinCheckoutApp /> },
  { path: "/pre-checkin", element: <PreCheckinApp /> },
  { path: "/planning-overview", element: <PlanningOverviewPage /> },
  { path: "/quality-check", element: <QualityCheckPage /> },
  { path: "/transport-planning", element: <TransportPlanningPage /> },
  { path: "/users", element: <UserManagementPage /> }
];

interface TenantRootProps {
  currentUser?: AuthenticatedUser;
}

export function TenantRoot({ currentUser }: TenantRootProps) {
  return (
    <TenantContainer
      tiles={[]}
      routes={TENANT_ROUTES}
      currentUser={currentUser}
    />
  );
}
